import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/book",
    name: "Books",
    component: () =>
        import(/* webpackChunkName: "books" */ "../views/Books.vue"),
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: () =>
        import(/* webpackChunkName: "analytics" */ "../views/Analytics.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
